import getEnv from "../../env";
import { AuthServices } from "../auth.services";
const env = getEnv();

// inspired from https://github.com/parse-community/Parse-SDK-JS/blob/5c140299109d2850982155ac1e1b907e1895fde0/src/LiveQueryClient.js#L345
const CLIENT_STATE = {
    INITIALIZED: "initialized",
    CONNECTING: "connecting",
    CONNECTED: "connected",
    CLOSED: "closed",
    RECONNECTING: "reconnecting",
    DISCONNECTED: "disconnected",
};

const generateInterval = (k) => {
    return Math.random() * Math.min(30, Math.pow(2, k) - 1) * 1000;
};

export class NotificationManager {
    token: string = "";
    companyId: string = "";

    webSocket: WebSocket;
    scopes = [
        "applicationSettings",
        "document",
        "bankTransaction",
        "expenseReport",
        "accountingItemImport",
        "accountingItemExport",
        "chat",
        "chatMessage",
        "chatUser",
        "invoice",
        "engagementLetter",
        "openPoints",
        "documentAndBankTransaction",
        "accountingPeriod",
    ];

    static listeners = [];

    reconnectHandle = null;
    state = CLIENT_STATE.INITIALIZED;
    attempts = 1;
    constructor(token, companyId: string) {
        this.token = token;
        this.companyId = companyId;
        this.instanciate();
    }

    private instanciate() {
        try {
            // debugger;
            // this.connected = false
            // console.log("NotificationManager instanciate= ")
            // debugger
            const wssUrl = env.WSS_URL;
            // debugger
            // if (!env.WSS_URL) {
            //     debugger // git-ignore
            //     return
            // }

            if (this.state !== CLIENT_STATE.RECONNECTING) {
                this.state = CLIENT_STATE.CONNECTING;
            }

            // const wssUrl = env.WSS_URL

            if (wssUrl) {
                if (this.token) {
                    // console.log("token= " + this.token)
                    this.webSocket = new WebSocket(`${wssUrl}?jwt=${this.token}`);

                    this.webSocket.onerror = (error) => {
                        // this.onMessage({
                        //     scope: "frontEvent",
                        //     text: "websocket error"
                        // })
                        this._handleWebSocketError(error);
                    };

                    this.webSocket.onopen = (event) => {
                        // stateDOM.innerHTML = "Connected.";
                        // this.connected = true;
                        // if (this.companyId) {
                        // console.log(this)
                        // console.log(event)
                        this._handleWebSocketOpen();
                        // }
                    };

                    this.webSocket.onmessage = (event) => {
                        // console.log(event.data);
                        const message_data = JSON.parse(event.data);

                        this.onMessage(message_data);

                        // if (message_data.type === "document_update") {
                        //     alert("document updated");
                        // }
                    };

                    this.webSocket.onclose = () => {
                        // console.log("closed")
                        this._handleWebSocketClose();
                        // stateDOM.innerHTML = "Closed";
                        // if (this.connected) {
                        //     try {
                        //         this.webSocket = new WebSocket(wssUrl);
                        //     } catch (e) {
                        //         console.error(e)
                        //     }
                        // }
                        // this.onMessage({
                        //     scope: "frontEvent",
                        //     text: "websocket closed"
                        // })
                    };
                }
            } else {
                debugger; // git-ignore
            }
        } catch (e) {
            console.error(e);
        }
    }

    // shouldOpen(): boolean {
    //     return this.state === CLIENT_STATE.INITIALIZED || this.state === CLIENT_STATE.DISCONNECTED;
    // }

    _handleWebSocketOpen() {
        // console.log("connected with companyId= ", this.companyId)
        this.attempts = 1;
        this.state = CLIENT_STATE.CONNECTED;
        // if (this.webSocket && this.connected) {
        // Send the msg object as a JSON-formatted string.
        this.webSocket.send(
            JSON.stringify({
                type: "subscription",
                companyId: this.companyId,
                scopes: this.scopes,
            }),
        );
        // } else {
        // debugger // git-ignore
        // }
    }

    _handleWebSocketClose() {
        if (this.state === CLIENT_STATE.DISCONNECTED) {
            return;
        }
        this.state = CLIENT_STATE.CLOSED;

        // this.emit(CLIENT_EMMITER_TYPES.CLOSE);
        // // Notify each subscription about the close
        // for (const subscription of this.subscriptions.values()) {
        //     subscription.emit(SUBSCRIPTION_EMMITER_TYPES.CLOSE);
        // }
        this._handleReconnect();
    }

    _handleWebSocketError(error: any) {
        // this.emit(CLIENT_EMMITER_TYPES.ERROR, error);
        // for (const subscription of this.subscriptions.values()) {
        //     subscription.emit(SUBSCRIPTION_EMMITER_TYPES.ERROR, error);
        // }
        console.error(error);
        this._handleReconnect();
    }

    _handleReconnect() {
        // if closed or currently reconnecting we stop attempting to reconnect
        if (this.state === CLIENT_STATE.DISCONNECTED) {
            return;
        }

        this.state = CLIENT_STATE.RECONNECTING;
        const time = generateInterval(this.attempts);

        // handle case when both close/error occur at frequent rates we ensure we do not reconnect unnecessarily.
        // we're unable to distinguish different between close/error when we're unable to reconnect therefore
        // we try to reconnect in both cases
        // server side ws and browser WebSocket behave differently in when close/error get triggered

        if (this.reconnectHandle) {
            clearTimeout(this.reconnectHandle);
        }

        this.reconnectHandle = setTimeout(
            (() => {
                this.attempts++;
                // this.connectPromise = resolvingPromise();
                this.instanciate();
            }).bind(this),
            time,
        );
    }

    unsubscribe() {
        // if (this.webSocket && this.connected) {
        if (this.webSocket) {
            console.log("Websocket -> ", "disconnect");
            this.webSocket.close();
        }
        // } else {
        //     debugger // git-ignore
        // }
    }

    onMessage(data) {
        for (const listener of NotificationManager.listeners) {
            if (!listener.callback) {
                continue;
            }
            const scopes = listener.scopes;
            if (typeof scopes === "string") {
                if (scopes === "all") {
                    listener.callback(data);
                } else if (scopes === data.scope) {
                    listener.callback(data);
                }
            } else if (listener.scopes.indexOf(data.scope) !== -1 && listener.callback) {
                listener.callback(data);
            }
        }
    }

    static addListener(scopes, component, callback) {
        if (scopes) {
            //
            // clean
            //
            for (let i = NotificationManager.listeners.length - 1; i >= 0; i--) {
                if (
                    !NotificationManager.listeners[i].component ||
                    !NotificationManager.listeners[i].callback
                ) {
                    NotificationManager.listeners.splice(i, 1);
                }
            }

            const listener = NotificationManager.listeners.find((l) => l.callback === callback);
            if (listener) {
                listener.scopes = scopes;
            } else {
                NotificationManager.listeners.push({
                    scopes,
                    component,
                    callback,
                });
            }
        }
    }

    static removeListener(callback) {
        for (let i = NotificationManager.listeners.length - 1; i >= 0; i--) {
            if (NotificationManager.listeners[i].callback === callback) {
                NotificationManager.listeners.splice(i, 1);
            }
        }
    }

    static async upsertNotificationManager(companyId): Promise<NotificationManager> {
        if (notificationManager) {
            if (notificationManager.companyId === companyId) {
                return;
            }
            notificationManager.unsubscribe();
            notificationManager = undefined;
        }
        if (!companyId) {
            return;
        }
        console.log("Websocket -> ", "connect");
        const token = await AuthServices.getUserToken();
        if (token) {
            // debugger
            notificationManager = new NotificationManager(token, companyId);
        } else {
            console.error("token not defined");
            notificationManager = undefined;
        }
        return notificationManager;
    }

    static deleteNotificationManager() {
        if (notificationManager) {
            notificationManager.unsubscribe();
            notificationManager = undefined;
        }
    }
}

export let notificationManager: NotificationManager;

// export function disconnectWebSocket() {
//     if (notificationManager) {
//         return notificationManager.unsubscribe()
//     } else {
//         console.error("No WebSocket")
//     }
// }
